import { dt } from '@primeuix/themes';

export const multiselectTheme = {
  padding: {
    y: '10px',
    x: '10px'
  },
  extend: {
    css: ({ dt: any }: any) => `
    .p-multiselect-header {
      background: ${dt('sd.backgrounds.panel')};
    }
  `,
    colorScheme: {
      light: {
        option: {
          focus: {
            background: '{sd.backgrounds.options.hover}'
          },
          group: {
            color: '{sd.text.primary}'
          }
        }
      }
    }
  }
};
